module.exports = __webpack_public_path__ + "static/media/book-reading-learning-svgrepo-com.a462fb21.svg";